module.exports = __webpack_public_path__ + "img/mask.966ce7d7.png";